import moment from 'moment'

const ordersControlsforms = [
  {
    name: 'Последние',
    slug: 'last',
    form: {
      statuses: [],
      payments: [],
      types: [],
      dateFrom: moment().subtract(3, 'months').format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      filterDate: 'createDate',
      onlyUpdates: false,
    }
  },
  {
    name: 'FIT-запросы',
    slug: 'fit',
    form: {
      statuses: [],
      payments: [],
      types: ['fit'],
      dateFrom: moment().subtract(3, 'months').format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      filterDate: 'createDate',
      onlyUpdates: false,
    }
  },
  {
    name: 'В работе',
    slug: 'inWork',
    form: {
      statuses: [],
      payments: [],
      types: [],
      dateFrom: moment().subtract(6, 'months').format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      filterDate: 'createDate',
      onlyUpdates: false,
    }
  },
  {
    name: 'Подтвержденные и неоплаченные',
    slug: 'confirmedUnpaid',
    form: {
      statuses: ['confirmed'],
      payments: ['unpaid', 'partially-paid'],
      types: [],
      dateFrom: moment().subtract(12, 'months').format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      filterDate: 'createDate',
      onlyUpdates: false,
    }
  },
  {
    name: 'Только с обновлениями',
    slug: 'onlyUpdates',
    form: {
      statuses: [],
      payments: [],
      types: [],
      dateFrom: moment().subtract(12, 'months').format('DD.MM.YYYY'),
      dateTo: moment().format('DD.MM.YYYY'),
      filterDate: 'createDate',
      onlyUpdates: true,
    }

  }
]

export default ordersControlsforms